export default __webpack_public_path__ + "static/media/raphael.ef31a259.jpg";